import { render } from "./BaseButtonActions.vue?vue&type=template&id=6cfd0b64&scoped=true"
import script from "./BaseButtonActions.vue?vue&type=script&lang=js"
export * from "./BaseButtonActions.vue?vue&type=script&lang=js"

import "./BaseButtonActions.vue?vue&type=style&index=0&id=6cfd0b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfd0b64"]])

export default __exports__